// ============ USER
export const FETCH_USER_LOADING = 'FETCH_USER_LOADING';
export const SET_USER_DATA = 'SET_USER_DATA';
export const FETCH_USER_ERROR = 'FETCH_USER_ERROR';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';

// ============ CREATORS

// fetch all creators
export const FETCH_CREATORS_LOADING = 'FETCH_CREATORS_LOADING';
export const FETCH_CREATORS_SUCCESS = 'FETCH_CREATORS_SUCCESS';
export const FETCH_CREATORS_ERROR = 'FETCH_CREATORS_ERROR';
export const CLEAR_CREATORS_LIST = 'CLEAR_CREATORS_LIST';

// load more creators
export const FETCH_LOAD_MORE_CREATORS_LOADING =
  'FETCH_LOAD_MORE_CREATORS_LOADING';
export const FETCH_LOAD_MORE_CREATORS_SUCCESS =
  'FETCH_LOAD_MORE_CREATORS_SUCCESS';
export const FETCH_LOAD_MORE_CREATORS_ERROR = 'FETCH_LOAD_MORE_CREATORS_ERROR';

// fetch creator
export const FETCH_CURRENT_CREATOR_LOADING = 'FETCH_CURRENT_CREATOR_LOADING';
export const FETCH_CURRENT_CREATOR_SUCCESS = 'FETCH_CURRENT_CREATOR_SUCCESS';
export const FETCH_CURRENT_CREATOR_ERROR = 'FETCH_CURRENT_CREATOR_ERROR';
export const CLEAR_CURRENT_CREATOR = 'CLEAR_CURRENT_CREATOR';

// creator nfts

export const FETCH_CREATOR_NFTS_LOADING = 'FETCH_CREATOR_NFTS_LOADING';
export const FETCH_CREATOR_NFTS_ERROR = 'FETCH_CREATOR_NFTS_ERROR';
export const FETCH_CREATOR_NFTS_SUCCESS = 'FETCH_CREATOR_NFTS_SUCCESS';

export const LOAD_MORE_CREATOR_NFTS_LOADING = 'LOAD_MORE_CREATOR_NFTS_LOADING';
export const LOAD_MORE_CREATOR_NFTS_ERROR = 'LOAD_MORE_CREATOR_NFTS_ERROR';
export const LOAD_MORE_CREATOR_NFTS_SUCCESS = 'LOAD_MORE_CREATOR_NFTS_SUCCESS';
export const CLEAR_CREATOR_NFTS = 'CLEAR_CREATOR_NFTS';
export const SET_NFTS_VIEW_TYPE = 'SET_NFTS_VIEW_TYPE';

// creator collections

export const FETCH_CREATOR_COLLECTIONS_LOADING =
  'FETCH_CREATOR_COLLECTIONS_LOADING';
export const FETCH_CREATOR_COLLECTIONS_ERROR =
  'FETCH_CREATOR_COLLECTIONS_ERROR';
export const FETCH_CREATOR_COLLECTIONS_SUCCESS =
  'FETCH_CREATOR_COLLECTIONS_SUCCESS';
export const CLEAR_CREATOR_COLLECTIONS = 'CLEAR_CREATOR_COLLECTIONS';

// ============= COLLECTIONS

// fetch all collections
export const FETCH_COLLECTIONS_LOADING = 'FETCH_COLLECTIONS_LOADING';
export const FETCH_COLLECTIONS_SUCCESS = 'FETCH_COLLECTIONS_SUCCESS';
export const FETCH_COLLECTIONS_ERROR = 'FETCH_COLLECTIONS_ERROR';

// load more collections
export const LOAD_MORE_COLLECTIONS_LOADING = 'LOAD_MORE_COLLECTIONS_LOADING';
export const LOAD_MORE_COLLECTIONS_SUCCESS = 'LOAD_MORE_COLLECTIONS_SUCCESS';
export const LOAD_MORE_COLLECTIONS_ERROR = 'LOAD_MORE_COLLECTIONS_ERROR';

// fetch collection
export const FETCH_COLLECTION_LOADING = 'FETCH_COLLECTION_LOADING';
export const FETCH_COLLECTION_SUCCESS = 'FETCH_COLLECTION_SUCCESS';
export const FETCH_COLLECTION_ERROR = 'FETCH_COLLECTION_ERROR';
export const CLEAR_COLLECTION_CURRENT = 'CLEAR_COLLECTION_CURRENT';
export const SET_COLLECTION_NFTS_VIEW_TYPE = 'SET_COLLECTION_NFTS_VIEW_TYPE';

// fetch filter collections
export const FETCH_FILTER_COLLECTIONS_LOADING =
  'FETCH_FILTER_COLLECTIONS_LOADING';
export const FETCH_FILTER_COLLECTIONS_SUCCESS =
  'FETCH_FILTER_COLLECTIONS_SUCCESS';
export const FETCH_FILTER_COLLECTIONS_ERROR = 'FETCH_FILTER_COLLECTIONS_ERROR';

// fetch collection rankings

export const FETCH_COLLECTION_RANKINGS_LOADING =
  'FETCH_COLLECTION_RANKINGS_LOADING';
export const FETCH_COLLECTION_RANKINGS_SUCCESS =
  'FETCH_COLLECTION_RANKINGS_SUCCESS';
export const FETCH_COLLECTION_RANKINGS_ERROR =
  'FETCH_COLLECTION_RANKINGS_ERROR';

// fetch featured collections

export const FETCH_FEATURED_COLLECTIONS_LOADING =
  'FETCH_FEATURED_COLLECTIONS_LOADING';
export const FETCH_FEATURED_COLLECTIONS_SUCCESS =
  'FETCH_FEATURED_COLLECTIONS_SUCCESS';
export const FETCH_FEATURED_COLLECTIONS_ERROR =
  'FETCH_FEATURED_COLLECTIONS_ERROR';

// ============= BLOCKCHAIN NFTS

// fetch blockchain nfts
export const FETCH_BLOCKCHAIN_NFTS_LOADING = 'FETCH_BLOCKCHAIN_NFTS_LOADING';
export const FETCH_BLOCKCHAIN_NFTS_SUCCESS = 'FETCH_BLOCKCHAIN_NFTS_SUCCESS';
export const FETCH_BLOCKCHAIN_NFTS_ERROR = 'FETCH_BLOCKCHAIN_NFTS_ERROR';
export const FETCH_MORE_BLOCKCHAIN_NFTS_LOADING =
  'FETCH_MORE_BLOCKCHAIN_NFTS_LOADING';
export const FETCH_MORE_BLOCKCHAIN_NFTS_SUCCESS =
  'FETCH_MORE_BLOCKCHAIN_NFTS_SUCCESS';
export const FETCH_MORE_BLOCKCHAIN_NFTS_ERROR =
  'FETCH_MORE_BLOCKCHAIN_NFTS_ERROR';

// fetch account collections
export const FETCH_ACC_COLLECTIONS_LOADING = 'FETCH_ACC_COLLECTIONS_LOADING';
export const FETCH_ACC_COLLECTIONS_SUCCESS = 'FETCH_ACC_COLLECTIONS_SUCCESS';
export const FETCH_ACC_COLLECTIONS_ERROR = 'FETCH_ACC_COLLECTIONS_ERROR';

export const CURRENT_COLLECTION_SUBMIT_LOADING =
  'CURRENT_COLLECTION_SUBMIT_LOADING';
export const SAVE_CURRENT_COLLECTION_SUCCESS =
  'SAVE_CURRENT_COLLECTION_SUCCESS';
export const UPDATE_CURRENT_COLLECTION_SUCCESS =
  'UPDATE_CURRENT_COLLECTION_SUCCESS';
export const DELETE_CURRENT_COLLECTION_SUCCESS =
  'DELETE_CURRENT_COLLECTION_SUCCESS';
export const ADD_DRAFT_COLLECTION = 'ADD_DRAFT_COLLECTION';
export const REPLACE_WITH_DRAFT_COLLECTION = 'REPLACE_WITH_DRAFT_COLLECTION';
export const DELETE_DRAFT_COLLECTION = 'DELETE_DRAFT_COLLECTION';
export const CURRENT_COLLECTION_ERROR = 'CURRENT_ACC_COLLECTION_ERROR';
export const RESET_CURRENT_COLLECTION = 'RESET_CURRENT_ACC_COLLECTION';

// ============= WALLETS

export const CONNECT_WALLET_LOADING = 'CONNECT_WALLET_LOADING';
export const CONNECT_WALLET_SUCCESS = 'CONNECT_WALLET_SUCCESS';
export const CONNECT_WALLET_ERROR = 'CONNECT_WALLET_ERROR';

// fetch account nfts

export const FETCH_ACC_NFTS_LOADING = 'FETCH_ACC_NFTS_LOADING';
export const FETCH_ACC_NFTS_SUCCESS = 'FETCH_ACC_NFTS_SUCCESS';
export const FETCH_ACC_NFTS_ERROR = 'FETCH_ACC_NFTS_ERROR';
export const RESET_ACC_NFTS = 'RESET_ACC_NFTS';

export const CURRENT_ACC_NFT_LOADING = 'CURRENT_ACC_NFT_LOADING';
export const SAVE_ACC_CURRENT_NFT_SUCCESS = 'SAVE_ACC_CURRENT_NFT_SUCCESS';
export const UPDATE_ACC_CURRENT_NFT_SUCCESS = 'UPDATE_ACC_CURRENT_NFT_SUCCESS';
export const DELETE_ACC_CURRENT_NFT_SUCCESS = 'DELETE_ACC_CURRENT_NFT_SUCCESS';
export const REVOKE_ACC_CURRENT_NFT_SUCCESS = 'REVOKE_ACC_CURRENT_NFT_SUCCESS';
export const WITHDRAW_ACC_CURRENT_NFT_SUCCESS =
  'WITHDRAW_ACC_CURRENT_NFT_SUCCESS';
export const TRANSFER_ACC_CURRENT_NFT_SUCCESS =
  'TRANSFER_ACC_CURRENT_NFT_SUCCESS';

export const CURRENT_ACC_NFT_ERROR = 'CURRENT_ACC_NFT_ERROR';
export const RESET_ACC_CURRENT_NFT = 'RESET_ACC_CURRENT_NFT';

export const VALIDATE_IMAGES_ACC_NFT_ERROR = 'VALIDATE_IMAGES_ACC_NFT_ERROR';

export const VALIDATE_IMAGES_ACC_NFT_SUCCESS =
  'VALIDATE_IMAGES_ACC_NFT_SUCCESS';

//fetch all nfts

export const FETCH_NFTS_LOADING = 'FETCH_NFTS_LOADING';
export const FETCH_NFTS_ERROR = 'FETCH_NFTS_ERROR';
export const FETCH_NFTS_SUCCESS = 'FETCH_NFTS_SUCCESS';
export const CLEAR_ALL_NFTS = 'CLEAR_ALL_NFTS';

// fetch nft properties rarity

export const FETCH_NFT_PROPERTIES_RARITY_LOADING =
  'FETCH_NFT_PROPERTIES_RARITY_LOADING';
export const FETCH_NFT_PROPERTIES_RARITY_ERROR =
  'FETCH_NFT_PROPERTIES_RARITY_ERROR';
export const FETCH_NFT_PROPERTIES_RARITY_SUCCESS =
  'FETCH_NFT_PROPERTIES_RARITY_SUCCESS';

//fetch nft

export const FETCH_CURRENT_NFT_LOADING = 'FETCH_CURRENT_NFT_LOADING';
export const FETCH_CURRENT_NFT_FOR_WITHDRAW_LOADING =
  'FETCH_CURRENT_NFT_FOR_WITHDRAW_LOADING';
export const FETCH_CURRENT_NFT_ERROR = 'FETCH_CURRENT_NFT_ERROR';
export const FETCH_CURRENT_NFT_SUCCESS = 'FETCH_CURRENT_NFT_SUCCESS';
export const FETCH_CURRENT_NFT_SUCCESS_FOR_WITHDRAW =
  'FETCH_CURRENT_NFT_SUCCESS_FOR_WITHDRAW';
export const CLEAR_CURRENT_NFT = 'CLEAR_CURRENT_NFT';
// load more nft

export const FETCH_NFTS_LOAD_MORE_SUCCESS = 'FETCH_NFTS_LOAD_MORE_SUCCESS';
export const FETCH_NFTS_LOAD_MORE_LOADING = 'FETCH_NFTS_LOAD_MORE_LOADING';
export const FETCH_NFTS_LOAD_MORE_ERROR = 'FETCH_NFTS_LOAD_MORE_ERROR';

//collection nfts

export const FETCH_COLLECTION_NFTS_LOADING = 'FETCH_COLLECTION_NFTS_LOADING';
export const FETCH_COLLECTION_NFTS_ERROR = 'FETCH_COLLECTION_NFTS_ERROR';
export const FETCH_COLLECTION_NFTS_SUCCESS = 'FETCH_COLLECTION_NFTS_SUCCESS';
export const CLEAR_COLLECTION_NFTS = 'CLEAR_COLLECTION_NFTS';

//fetch omni-search nfts

export const FETCH_OMNI_SEARCH_NFTS_LOADING = 'FETCH_SEARCH_NFTS_LOADING';
export const FETCH_OMNI_SEARCH_NFTS_ERROR = 'FETCH_SEARCH_NFTS_ERROR';
export const FETCH_OMNI_SEARCH_NFTS_SUCCESS = 'FETCH_SEARCH_NFTS_SUCCESS';

//

export const FETCH_CATERORIES = 'GET_CATERORIES';

// ============= TRANSACTIONS

// fetch all transactions
export const FETCH_TRANSACTIONS_LOADING = 'FETCH_TRANSACTIONS_LOADING';
export const FETCH_TRANSACTIONS_SUCCESS = 'FETCH_TRANSACTIONS_SUCCESS';
export const FETCH_TRANSACTIONS_SUCCESS_STACK =
  'FETCH_TRANSACTIONS_SUCCESS_STACK';
export const FETCH_TRANSACTIONS_ERROR = 'FETCH_TRANSACTIONS_ERROR';
export const CLEAR_TRANSACTION_LIST = 'CLEAR_TRANSACTION_LIST';

//LayoutSetting

// TODO: must be deleted after old account deleted
export const UPDATE_LAYOUT_SETTINGS = 'UPDATE_LAYOUT_SETTINGS';

// Collection Stats

export const FETCH_COLLECTION_STATS_SUCCESS = 'FETCH_COLLECTION_STATS_SUCCESS';
export const FETCH_COLLECTION_STATS_LOADING = 'FETCH_COLLECTION_STATS_LOADING';
export const FETCH_COLLECTION_STATS_ERROR = 'FETCH_COLLECTION_STATS_ERROR';

// Walllet balance

export const FETCH_WALLET_BALANCE_SUCCESS = 'FETCH_WALLET_BALANCE_SUCCESS';
export const FETCH_WALLET_BALANCE_LOADING = 'FETCH_WALLET_BALANCE_LOADING';
export const FETCH_WALLET_BALANCE_ERROR = 'FETCH_WALLET_BALANCE_ERROR';
export const SET_WALLET_CURRENCY = 'SET_WALLET_CURRENCY';

// creators stats

export const FETCH_CREATORS_STATS_SUCCESS = 'FETCH_CREATORS_STATS_SUCCESS';
export const FETCH_CREATORS_STATS_LOADING = 'FETCH_CREATORS_STATS_LOADING';
export const FETCH_CREATORS_STATS_ERROR = 'FETCH_CREATORS_STATS_ERROR';

// account creator

export const FETCH_ACCOUNT_CREATOR_SUCCESS = 'FETCH_ACCOUNT_CREATOR_SUCCESS';
export const FETCH_ACCOUNT_CREATOR_LOADING = 'FETCH_ACCOUNT_CREATOR_LOADING';
export const FETCH_ACCOUNT_CREATOR_ERROR = 'FETCH_ACCOUNT_CREATOR_ERROR';

// SERVICE FEE

export const FETCH_SERVICE_FEE_LOADING = 'FETCH_SERVICE_FEE_LOADING';
export const FETCH_SERVICE_FEE_SUCCESS = 'FETCH_SERVICE_FEE_SUCCESS';
export const FETCH_SERVICE_FEE_ERROR = 'FETCH_SERVICE_FEE_ERROR';

// Curencies

export const FETCH_CURRENCIES_LOADING = 'FETCH_CURRENCIES_LOADING';
export const FETCH_CURRENCIES_SUCCESS = 'FETCH_CURRENCIES_SUCCESS';
export const FETCH_CURRENCIES_ERROR = 'FETCH_CURRENCIES_ERROR';

//ACCOUNT COLLECTIONS

export const FETCH_ACCOUNT_COLLECTION_NFTS_LOADING =
  'FETCH_ACCOUNT_COLLECTION_NFTS_LOADING';
export const FETCH_ACCOUNT_COLLECTION_NFTS_ERROR =
  'FETCH_ACCOUNT_COLLECTION_NFTS_ERROR';
export const FETCH_ACCOUNT_COLLECTION_NFTS_SUCCESS =
  'FETCH_ACCOUNT_COLLECTION_NFTS_SUCCESS';
export const CLEAR_ACCOUNT_COLLECTION_NFTS_DATA =
  'CLEAR_ACCOUNT_COLLECTION_NFTS_DATA';
export const ADD_ACCOUNT_COLLECTION_NFT = 'ADD_ACCOUNT_COLLECTION_NFT';
export const DELETE_ACCOUNT_COLLECTION_NFT = 'DELETE_ACCOUNT_COLLECTION_NFT';
export const UPDATE_ACCOUNT_COLLECTION_NFT = 'UPDATE_ACCOUNT_COLLECTION_NFT';
export const TRANSFER_ACCOUNT_COLLECTION_NFT =
  'TRANSFER_ACCOUNT_COLLECTION_NFT';

// ACCOUNT NEXT COMPANY

export const FETCH_COMPANY_TOKEN_ERROR = 'FETCH_COMPANY_TOKEN_ERROR';
export const FETCH_COMPANY_TOKEN_LOADING = 'FETCH_COMPANY_TOKEN_LOADING';
export const FETCH_COMPANY_TOKEN_SUCCESS = 'FETCH_COMPANY_TOKEN_SUCCESS';
export const FETCH_COMPANY_SUCCESS = 'FETCH_COMPANY_SUCCESS';

// CART

export const SET_CART_OPEN = 'SET_CART_OPEN';
export const SET_CART_LOADING = 'SET_CART_LOADING';
export const ADD_NFT_TO_CART = 'ADD_NFT_TO_CART';
export const REMOVE_NFT_FROM_CART = 'REMOVE_NFT_FROM_CART';
export const UPDATE_CART_DATA = 'UPDATE_CART_DATA';

// GLOBAL PROPERTIES

export const SET_TERMINAL_ACCOUNT_MOUNTED = 'SET_TERMINAL_ACCOUNT_MOUNTED';
export const SET_HOORY_WIDGET_HIDERS_COUNT = 'SET_HOORY_WIDGET_HIDERS_COUNT';

// MERCHANDISE

export const FETCH_MERCHANDISE_ORDERS_SUCCESS =
  'FETCH_MERCHANDISE_ORDERS_SUCCESS';
export const FETCH_MERCHANDISE_ORDERS_ERROR = 'FETCH_MERCHANDISE_ORDERS_ERROR';
export const FETCH_MERCHANDISE_ORDERS_LOADING =
  'FETCH_MERCHANDISE_ORDERS_LOADING';
